<template>
  <v-container
    id="app-closing"
    class="fill-height"
  >
    <h3 class="mt-50 text-center">
      {{ $t('button.dw_telecolection') }}
    </h3>
  </v-container>
</template>

<script>
import { Operations } from '@/modules/Operations'
import { $alert } from '@/modules/Utils'

export default {
  name: 'ClosingView',

  mounted () {
    Operations.telecollection(
      (response) => {
        $alert(response, 'success')
        this.$router.replace('/home')
      },
      (error) => {
        if (this.$store.getters.externalAction) {
          CissAndroid.sendError({ message: error })
        } else {
          $alert(error)
          this.$router.replace('/home')
        }
      }
    )
  }
}
</script>
